/* Trees cart system
   - Ajax add to cart from any product form, with a toast (bottom-left)
   - Cart page: working remove (with Undo) and quantity +/- without reloads
   - Keeps the header cart badge in sync
   No dependencies. */
(function () {
  'use strict';
  if (window.__tcCart) return;
  window.__tcCart = true;

  var cfg = window.TreesCart || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var URLS = {
    add: root + 'cart/add.js',
    change: root + 'cart/change.js',
    cart: root + 'cart.js',
    page: root + 'cart',
    checkout: root + 'checkout'
  };
  var state = { cart: null };
  var chain = Promise.resolve();
  var region = null;

  function onCartPage() { return document.body.classList.contains('template-cart'); }

  /* ---------- helpers ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function withSep(v, dec, thou, decSep) {
    var parts = v.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
    return parts.join(decSep);
  }
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    var fmt = cfg.moneyFormat || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case 'amount_no_decimals': return withSep(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withSep(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSep(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withSep(n, 2, "'", '.');
        default: return withSep(n, 2, ',', '.');
      }
    });
  }
  function readJson(r) {
    return r.json().then(function (d) { return { ok: r.ok, d: d }; });
  }
  function errMessage(d, fallback) {
    return (d && (d.description || d.message)) || fallback;
  }

  /* ---------- toasts ---------- */
  function getRegion() {
    if (region && document.body.contains(region)) return region;
    region = el('div', 'tc-toasts');
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    document.body.appendChild(region);
    return region;
  }

  var CHECK = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var WARN = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.01"/></svg>';

  function toast(opts) {
    var host = getRegion();
    var tone = opts.tone || 'success';
    var node = el('div', 'tc-toast tc-toast--' + tone);

    var media = el('div', 'tc-toast__media');
    if (opts.image) {
      var im = document.createElement('img');
      im.src = opts.image;
      im.alt = '';
      im.width = 56;
      im.height = 56;
      media.appendChild(im);
    } else {
      media.classList.add('tc-toast__media--icon');
      media.innerHTML = tone === 'error' ? WARN : CHECK;
    }

    var body = el('div', 'tc-toast__body');
    if (opts.kicker) body.appendChild(el('div', 'tc-toast__kicker', opts.kicker));
    body.appendChild(el('div', 'tc-toast__title', opts.title));
    if (opts.text) body.appendChild(el('div', 'tc-toast__text', opts.text));

    if (opts.actions && opts.actions.length) {
      var actions = el('div', 'tc-toast__actions');
      opts.actions.forEach(function (a) {
        var node2;
        if (a.href) {
          node2 = el('a', 'tc-toast__btn' + (a.primary ? ' tc-toast__btn--primary' : ''), a.label);
          node2.href = a.href;
        } else {
          node2 = el('button', 'tc-toast__btn' + (a.primary ? ' tc-toast__btn--primary' : ''), a.label);
          node2.type = 'button';
          node2.addEventListener('click', function () {
            dismiss();
            if (a.onClick) a.onClick();
          });
        }
        actions.appendChild(node2);
      });
      body.appendChild(actions);
    }

    var closeBtn = el('button', 'tc-toast__close');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Dismiss');
    closeBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

    var duration = opts.timeout || (tone === 'error' ? 7000 : 6000);
    var bar = el('div', 'tc-toast__bar');
    bar.style.animationDuration = duration + 'ms';

    node.appendChild(media);
    node.appendChild(body);
    node.appendChild(closeBtn);
    node.appendChild(bar);

    var timer = null;
    var remaining = duration;
    var startedAt = 0;
    var gone = false;

    function arm() {
      startedAt = Date.now();
      timer = setTimeout(dismiss, remaining);
    }
    function pause() {
      if (timer == null) return;
      clearTimeout(timer);
      timer = null;
      remaining -= Date.now() - startedAt;
    }
    function dismiss() {
      if (gone) return;
      gone = true;
      clearTimeout(timer);
      node.classList.remove('is-in');
      node.classList.add('is-out');
      setTimeout(function () { if (node.parentNode) node.parentNode.removeChild(node); }, 260);
    }
    node._dismiss = dismiss;

    closeBtn.addEventListener('click', dismiss);
    node.addEventListener('mouseenter', pause);
    node.addEventListener('mouseleave', function () { if (!gone && timer == null) arm(); });
    node.addEventListener('focusin', pause);
    node.addEventListener('focusout', function () { if (!gone && timer == null) arm(); });

    // keep at most 3 toasts on screen
    var existing = host.querySelectorAll('.tc-toast');
    for (var i = 0; i <= existing.length - 3; i++) {
      if (existing[i]._dismiss) existing[i]._dismiss();
    }

    host.appendChild(node);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { node.classList.add('is-in'); });
    });
    arm();
    return dismiss;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !region) return;
    var all = region.querySelectorAll('.tc-toast');
    var last = all[all.length - 1];
    if (last && last._dismiss) last._dismiss();
  });

  /* ---------- cart state + header badge ---------- */
  function updateBadges(count, animate) {
    var badges = document.querySelectorAll('.cart-badge');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      var changed = String(b.textContent).trim() !== String(count);
      b.textContent = count;
      b.hidden = count === 0;
      if (animate && changed) {
        b.classList.remove('tc-bump');
        void b.offsetWidth;
        b.classList.add('tc-bump');
      }
    }
  }
  function refreshCart(silent) {
    return fetch(URLS.cart, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.cart = cart;
        updateBadges(cart.item_count, !silent);
        return cart;
      });
  }

  /* ---------- add to cart ---------- */
  function submitButtons(form) {
    var list = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]'));
    if (form.id) {
      var outside = document.querySelectorAll('[form="' + form.id + '"]');
      for (var i = 0; i < outside.length; i++) if (list.indexOf(outside[i]) === -1) list.push(outside[i]);
    }
    return list;
  }
  function setLoading(buttons, on) {
    buttons.forEach(function (b) {
      b.classList.toggle('tc-loading', on);
      b.setAttribute('aria-busy', on ? 'true' : 'false');
      if (on) { b.dataset.tcWasDisabled = b.disabled ? '1' : ''; b.disabled = true; }
      else { b.disabled = b.dataset.tcWasDisabled === '1'; }
    });
  }
  function showAdded(item, added) {
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var n = added || 1;
    var bits = [];
    if (variant) bits.push(variant);
    bits.push('Qty ' + n);
    bits.push(money(item.final_price * n));
    var actions = [];
    if (!onCartPage()) actions.push({ label: 'View cart', href: URLS.page });
    actions.push({ label: 'Checkout', href: URLS.checkout, primary: true });
    toast({
      kicker: 'Added to your cart',
      title: item.product_title,
      text: bits.join(' · '),
      image: (item.featured_image && item.featured_image.url) || item.image || '',
      actions: actions
    });
  }
  function addToCart(form) {
    var buttons = submitButtons(form);
    setLoading(buttons, true);
    var fallback = false;
    var data = new FormData(form);
    var addedQty = parseInt(data.get('quantity'), 10) || 1;
    return fetch(URLS.add, {
      method: 'POST',
      body: data,
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(readJson)
      .then(function (res) {
        if (!res.ok || res.d.status) throw new Error(errMessage(res.d, 'This item could not be added.'));
        return res.d;
      })
      .then(function (item) {
        return refreshCart().then(function () {
          showAdded(item, addedQty);
          if (onCartPage()) return refreshPage();
        });
      })
      .catch(function (err) {
        if (err instanceof TypeError) { fallback = true; return; }
        toast({ tone: 'error', title: 'Could not add to cart', text: err.message });
      })
      .then(function () {
        setLoading(buttons, false);
        if (fallback) form.submit();
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add(\.js)?(\?.*)?$/.test(action)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addToCart(form);
  }, true);

  /* ---------- cart page ---------- */
  function setBusy(on) {
    var main = document.querySelector('main');
    if (main) {
      main.classList.toggle('tc-updating', on);
      main.setAttribute('aria-busy', on ? 'true' : 'false');
    }
  }
  function refreshPage() {
    return fetch(URLS.page, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('main');
        var main = document.querySelector('main');
        if (fresh && main) main.innerHTML = fresh.innerHTML;
        if (state.cart) updateBadges(state.cart.item_count);
      });
  }
  function changeLine(line, qty) {
    chain = chain.then(function () {
      setBusy(true);
      return fetch(URLS.change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty }),
        credentials: 'same-origin'
      })
        .then(readJson)
        .then(function (res) {
          if (!res.ok || res.d.status) throw new Error(errMessage(res.d, 'The cart could not be updated.'));
          var cart = res.d;
          var item = cart.items[line - 1];
          state.cart = cart;
          if (qty > 0 && item && item.quantity < qty) {
            toast({ tone: 'error', title: 'Quantity limited', text: 'Only ' + item.quantity + ' of this item are available.' });
          }
          return refreshPage();
        })
        .catch(function (err) {
          if (err instanceof TypeError) { window.location.reload(); return; }
          toast({ tone: 'error', title: 'Cart not updated', text: err.message });
          return refreshCart().then(refreshPage);
        })
        .then(function () { setBusy(false); });
    });
    return chain;
  }
  function removeLine(line) {
    var ready = state.cart ? Promise.resolve(state.cart) : refreshCart();
    return ready.then(function (cart) {
      var item = cart.items[line - 1];
      return changeLine(line, 0).then(function () {
        if (!item) return;
        toast({
          title: 'Removed from cart',
          text: item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : ''),
          image: (item.featured_image && item.featured_image.url) || item.image || '',
          actions: [{
            label: 'Undo',
            primary: true,
            onClick: function () {
              fetch(URLS.add, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: item.variant_id, quantity: item.quantity, properties: item.properties || {} }] }),
                credentials: 'same-origin'
              })
                .then(readJson)
                .then(function (res) {
                  if (!res.ok || res.d.status) throw new Error(errMessage(res.d, 'Could not restore this item.'));
                  return refreshCart();
                })
                .then(refreshPage)
                .then(function () { toast({ title: 'Item restored', text: item.product_title }); })
                .catch(function (err) { toast({ tone: 'error', title: 'Could not restore', text: err.message }); });
            }
          }]
        });
      });
    });
  }

  var qtyTimers = {};
  function commitQty(input) {
    var line = parseInt(input.getAttribute('data-index'), 10);
    if (!line) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 1;
    if (qty === 0) { removeLine(line); return; }
    var max = parseInt(input.getAttribute('max'), 10);
    if (!isNaN(max) && qty > max) {
      qty = max;
      input.value = max;
      toast({ tone: 'error', title: 'Quantity limited', text: 'Only ' + max + ' of this item are available.' });
    }
    changeLine(line, qty);
  }
  function scheduleCommit(input) {
    var key = input.getAttribute('data-index');
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () { commitQty(input); }, 450);
  }

  document.addEventListener('click', function (e) {
    if (!onCartPage()) return;
    var t = e.target;
    if (!t || !t.closest) return;

    var rm = t.closest('cart-remove-button');
    if (rm) {
      e.preventDefault();
      e.stopPropagation();
      var line = parseInt(rm.getAttribute('data-index'), 10);
      if (line) removeLine(line);
      return;
    }

    var qb = t.closest('.quantity__button');
    if (qb && qb.closest('.cart-item')) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = qb.closest('quantity-input') || qb.parentNode;
      var input = wrap.querySelector('.quantity__input');
      if (!input || qb.disabled) return;
      var step = parseInt(input.getAttribute('step'), 10) || 1;
      var cur = parseInt(input.value, 10) || 1;
      var next = qb.getAttribute('name') === 'plus' ? cur + step : Math.max(1, cur - step);
      var max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max) && next > max) {
        toast({ tone: 'error', title: 'Quantity limited', text: 'Only ' + max + ' of this item are available.' });
        return;
      }
      input.value = next;
      scheduleCommit(input);
    }
  }, true);

  document.addEventListener('change', function (e) {
    if (!onCartPage()) return;
    var t = e.target;
    if (t && t.classList && t.classList.contains('quantity__input') && t.closest('.cart-item')) {
      e.stopPropagation();
      scheduleCommit(t);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!onCartPage() || e.key !== 'Enter') return;
    var t = e.target;
    if (t && t.classList && t.classList.contains('quantity__input')) {
      e.preventDefault();
      clearTimeout(qtyTimers[t.getAttribute('data-index')]);
      commitQty(t);
    }
  }, true);

  // prime state for Undo and keep the badge accurate on every page
  refreshCart(true).catch(function () {});
})();
